// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"9f9c8120","66":"8064b9e6","145":"5b1dbdcd","190":"f3d393e8","613":"74fe177b","906":"bf269f6e","948":"4eda7ba6","957":"f606cbeb","969":"a01907e8"}[chunkId] + ".chunk.js";
};